import { defaultTo } from '../utils/bits'
import { signUserFunction } from './gallery-properties.flow'

import envRaw from '../utils/env-raw'

export default signUserFunction(calcUseRawImagesAsThumbs)

function calcUseRawImagesAsThumbs(rawVal, calcProp) {
  const highlight_period = calcProp('highlight_period')
  const use_raw_images_as_thumbs = defaultTo(rawVal, false)
  return use_raw_images_as_thumbs || highlight_period >= 1 || envRaw.liveEditMode
}
